import { send } from 'server';

export const getBonusTemplate = ({ bonusCodes }) => send({
    ID: 31079,
    responses: [31080, 31081],
    description: 'Get Buy-In Bonus Template Details',
    bonusTemplateCodes: bonusCodes,
    returnGamingContexts: false,
    returnWageringCoefficients: false
});
